class ConstantDataGridString {
    static START_PAGE_NUMBER = 0;
    static DATA_GRID_PAGE_SIZE = 25;
    static PLATE_DATA_GRID_ROW_HEIGHT = 45;
    static DATA_GRID_ROW_HEIGHT = 41;
    static DATA_GRID_ROW_SELECTION = "multiple";
}
export default ConstantDataGridString;